<template>
    <div class="thumbnails-placeholder">
        <Placeholder class='thumbnail-placeholder'/>
        <Placeholder class='thumbnail-placeholder'/>
        <Placeholder class='thumbnail-placeholder'/>
    </div>
</template>

<script>
import Placeholder from '@/ecom/components/loading/Placeholder.vue';

export default {
    components: {Placeholder}    
}
</script>

<style lang="scss" scoped>
.thumbnails-placeholder{
    display: flex;
    flex-direction: column;
    gap: 20px;

    @media(max-width: 970px){
        flex-direction: row;
        flex-wrap: wrap;
        order: 1; //Swap thumbnails to go underneath main image
    }
}
.thumbnail-placeholder{
    width: 150px;
    height: 150px;
    object-fit: cover;
    object-position: 50% 0;

    @media (max-width: 1580px) {
        width: 100px;
        height: 100px;
    }

    @media (max-width: 768px) {
        width: 80px;
        height: 80px;
    }
}
</style>